//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import regionSeatLibs from 'utils/regionSeatLibs'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
export default {
  name: 'OrderList',
  $dictKeyList: [
    {
      key: '3',
      name: '订单状态',
    },
  ],
  data() {
    const that = this
    return {
      filterForm: {
        orderCategory: 3, //2: 托管订单，3：流转订单
        trustee: '',
        villageId: '',
        cropId: '',
        workType: '',
        statusFlag: '',
        trusteeAccountId: '',
      },
      regionProps: {
        value: 'i',
        label: 'n',
        children: 'c',
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, children, label, value, data } = node
          // 直辖市的二级（例：海淀区）flag：true代表直辖市
          if (level == 2 && children.length == 0) {
            that.getChildRegion(value, level >= 3, resolve, true)
          }
          if (level == 3 && children.length == 0 && label != '市辖区') {
            let leaf = false
            if (data.flag) {
              leaf = true
            } else {
              leaf = false
            }
            that.getChildRegion(value, leaf, resolve)
          } else if (level >= 4) {
            that.getChildRegion(value, level >= 4, resolve)
          } else {
            resolve()
          }
        },
      },
      regionData: Object.freeze(regionData),
      checkedRegionData: [],
      cropData: [],
      workTypeData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      orders: [],
    }
  },
  filters: {
    formatDate(value) {
      let result = ''
      let ary = value.split('-')
      result = `${ary[0]}年${ary[1]}月${ary[2]}日`
      return result
    },
  },
  watch: {
    'filterForm.cropId'(newValue) {
      if (newValue != 0) {
        this.filterForm.workType = ''
        this.workTypeData = []
        this.getCropWork2({ cropId2: newValue })
      }
    },
    checkedRegionData(n) {
      this.filterForm.villageId = n[n.length - 1]
    },
  },
  mounted() {
    this.filterForm.trusteeAccountId = this.$route.query.$businessAccountId
    this.getOrderList()
    this.getAllCropList()
    this.getCropWork2()
  },
  methods: {
    /**
     * @descripttion: 获取地区子级数据
     * @Author: juanjuanhui
     * @Date: 2022-04-02 15:45:04
     * @param {*} value 当前节点的value
     * @param {*} leaf 当前节点的leaf
     * @param {*} resolve
     * @param {*} flag 是否是直辖市的标志 非必传
     */
    getChildRegion(value, leaf, resolve, flag) {
      this.$http.common.getChildRegion({ pid: value }).then((res) => {
        let nodes = res.data
        if (flag) {
          nodes.forEach((item) => {
            item.leaf = leaf
            item.flag = flag
          })
        } else {
          nodes.forEach((item) => {
            item.leaf = leaf
          })
        }
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes)
      })
    },
    /**
     * @descripttion: 获取种植作物下拉框数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:12:00
     */
    getAllCropList() {
      this.$http.common.getAllCropList().then((res) => {
        this.cropData = res.data
      })
    },
    /**
     * @descripttion: 获取作业类型二级数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:18:11
     */
    getCropWork2(params) {
      this.$http.common.getCropWork2(params).then((res) => {
        this.workTypeData = res.data
      })
    },
    /**
     * @descripttion: 查询机具
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:33:18
     */
    handleFilterPro() {
      this.pagination.currentPage = 1
      this.getOrderList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:34:18
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.checkedRegionData = []
      this.pagination.currentPage = 1
      this.getOrderList()
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:35:18
     */
    getAllFilters() {
      this.allFilters = { ...this.filterForm }
      if (this.allFilters.cropId == 0) {
        delete this.allFilters.cropId
      }
      if (this.allFilters.workType == 0) {
        delete this.allFilters.workType
      }
      if (this.allFilters.statusFlag == 0) {
        delete this.allFilters.statusFlag
      }
    },
    /**
     * @descripttion: 获取订单列表
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:18:08
     * @param {*}
     */
    getOrderList() {
      this.getAllFilters()
      let { currentPage, pageSize } = this.pagination
      let params = { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.$http.order.getOrderList(params).then((res) => {
        let { recordTotal, content: orders } = res.data
        this.pagination.recordTotal = recordTotal
        this.orders = orders
      })
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:24:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getOrderList()
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:04:18
     * @param {*} params
     */
    handleLookDetail(params) {
      this.$router.push({
        path: '/cooperative/transfer/order/detail',
        query: { id: params.id },
      })
    },
  },
}
